import { Injectable } from '@angular/core';
import { CanActivate, Router, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService {

  constructor(
    private authService: AuthService,
    private router : Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url = state.url;

    let data = route.data;
    return this.checkLogin(url, data);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  checkLogin(url: any, data: any) {
    let tok = localStorage.getItem('token')
    if (tok) {
         return true;
    }
      this.router.navigate(['/auth/sign-in'], { queryParams: { attemptedUrl: url } });
    return false;
  }

  canDeactivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot){
      if(!localStorage.getItem('token')){
        return false;
      }else{
        return true;
      }
  }
}


